import { AxiosRequestConfig } from 'axios';

import { request } from '../request';
import {
  IDeleteNpcReq,
  IDeleteNpcResp,
  IGetNpcPrivacySettingReq,
  IGetNpcPrivacySettingResp,
  IUnbindNpcReq,
  IUnbindNpcResp,
  IUpdateNpcGroupChatSettingReq,
  IUpdateNpcGroupChatSettingResp,
  IUpdateNpcPlotSettingReq,
  IUpdateNpcPlotSettingResp,
  IUpdateNpcPrivacySettingReq,
  IUpdateNpcPrivacySettingResp,
} from '../types/npc';

export const postGetNpcPrivacySetting = (
  data: IGetNpcPrivacySettingReq,
  config?: AxiosRequestConfig
): Promise<IGetNpcPrivacySettingResp> => {
  const url = '/weaver/api/v1/ugc/get_npc_privacy_setting';
  return request.post(url, data, config || {});
};

export const postUpdatePrivacySetting = (
  data: IUpdateNpcPrivacySettingReq,
  config?: AxiosRequestConfig
): Promise<IUpdateNpcPrivacySettingResp> => {
  const url = '/weaver/api/v1/npc/update_privacy_setting';
  return request.post(url, data, config || {});
};

export const postUpdateNpcGroupChatSetting = (
  data: IUpdateNpcGroupChatSettingReq,
  config?: AxiosRequestConfig
): Promise<IUpdateNpcGroupChatSettingResp> => {
  const url = '/weaver/api/v1/npc/update_group_chat_setting';
  return request.post(url, data, config || {});
};

export const postUpdateNpcPlotSetting = (
  data: IUpdateNpcPlotSettingReq,
  config?: AxiosRequestConfig
): Promise<IUpdateNpcPlotSettingResp> => {
  const url = '/weaver/api/v1/ugc/update_npc_plot_setting';
  return request.post(url, data, config || {});
};

export const postDeleteNpc = (
  data: IDeleteNpcReq,
  config?: AxiosRequestConfig
): Promise<IDeleteNpcResp> => {
  const url = '/weaver/api/v1/npc/user_delete';
  return request.post(url, data, config || {});
};

export const postUnbindNpc = (
  data: IUnbindNpcReq,
  config?: AxiosRequestConfig
): Promise<IUnbindNpcResp> => {
  const url = '/weaver/api/v1/npc/user_unbind';
  return request.post(url, data, config || {});
};
